import { Grid, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { deletePI } from "../../../services/api";
import { useState, useEffect } from "react";
import FileInput from "../../commons/FileInput.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import moment from "moment";
import { editPI } from "./../../../services/api";
import { DeleteDialog } from "../../commons/dialog.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

const initialInput = {
  pmode: 1,
  form: "",
  serial: "",
  code: "",
  date: "",

  contract_no: "",
  contract_date: "",

  provider: null,
  provider_name: "",
  provider_tax: "",
  provider_address: "",

  customer_name: "",
  customer_tax: "",
  customer_address: "",

  amount: "",
  vat: "",
  vat_rate: 0,
  total: "",
  in_word: "",
  xml: "",
  pdf: "",
  products: [],

  itemcost: null,
  link: "",
  note: "",
};
const EditPI = ({ initialData, onEditResponse, onDeleteResponse }) => {
  // custom hook
  const [t] = useTranslation();
  // state
  const [input, setInput] = useState({ ...initialInput });
  const handleDelete = () => {
    return deletePI(initialData.id);
  };
  useEffect(() => {
    if (!initialData) return;
    setInput((prev) => ({
      ...initialData,
      pdf: "",
    }));
  }, [initialData]);
  // method
  const handleSubmit = () => {
    const files = new FormData();
    // files.append('pmode', input.pmode)
    input.pdf && files.append("pdf", input.pdf);
    input.form && files.append("form", input.form);
    input.serial && files.append("serial", input.serial);
    input.code && files.append("code", input.code);
    input.date && files.append("date", moment(input.date).format("YYYY-MM-DD"));
    input.contract_no && files.append("contract_no", input.contract_no);
    // input.provider?.id && files.append('provider_id', input.provider?.id)
    input.provider_name && files.append("provider_name", input.provider_name);
    input.provider_tax && files.append("provider_tax", input.provider_tax);
    input.provider_address && files.append("provider_address", input.provider_address);
    input.customer_name && files.append("customer_name", input.customer_name);
    input.customer_tax && files.append("customer_tax", input.customer_tax);
    input.customer_address && files.append("customer_address", input.customer_address);
    files.append("amount", input.amount || 0);
    files.append("vat", input.vat || 0);
    files.append("vat_rate", input.vat_rate || 0);
    files.append("total", input.total || 0);
    // input.in_word && files.append('in_word', input.in_word)
    input.link && files.append("link", input.link);
    input.note && files.append("note", input.note);
    // input.itemcost?.id && files.append('itemcost_id', input.itemcost?.id)
    // input.products && files.append('products', input.products)
    return editPI(initialData.id, files);
  };

  if (initialData)
    return (
      <div align="left">
        <h2 align="center">{t("Chỉnh sửa thông tin hóa đơn đầu vào")}</h2>
        <Grid container spacing={2} columns={10}>
          <Grid item sm={1} xs={2}>
            PDF file
          </Grid>
          <Grid item sm={3} xs={3}>
            <FileInput accept=".pdf" fullWidth value={input.pdf || ""} onChange={(file) => setInput((prev) => ({ ...prev, pdf: file }))} />
          </Grid>
          <Grid item sm={6} />

          <Grid item sm={1} xs={2}>
            {t("Tên người bán")}
          </Grid>
          <Grid item sm={6} xs={8}>
            <TextField fullWidth value={input.provider_name || ""} onChange={(e) => setInput((prev) => ({ ...prev, provider_name: e.target.value }))} />
          </Grid>

          <Grid item sm={1} xs={2}>
            {t("Mã số thuế người bán")}
          </Grid>
          <Grid item sm={2} xs={3}>
            <TextField fullWidth value={input.provider_tax || ""} onChange={(e) => setInput((prev) => ({ ...prev, provider_tax: e.target.value, provider: null }))} />
          </Grid>
          <Grid item sm={1} xs={2}>
            {t("Địa chỉ người bán")}
          </Grid>
          <Grid item sm={9} xs={8}>
            <TextField fullWidth value={input.provider_address || ""} onChange={(e) => setInput((prev) => ({ ...prev, provider_address: e.target.value }))} />
          </Grid>
          {/* <Grid item sx={5} sm={6}/> */}
          <Grid item sm={1} xs={2}>
            {t("Tên người mua")}
          </Grid>
          <Grid item sm={6} xs={8}>
            <TextField fullWidth value={input.customer_name || ""} onChange={(e) => setInput((prev) => ({ ...prev, customer_name: e.target.value }))} />
          </Grid>
          <Grid item sm={1} xs={2}>
            {t("Mã số thuế người mua")}
          </Grid>
          <Grid item sm={2} xs={3}>
            <TextField fullWidth value={input.customer_tax || ""} onChange={(e) => setInput((prev) => ({ ...prev, customer_tax: e.target.value, provider: null }))} />
          </Grid>
          <Grid item sm={1} xs={2}>
            {t("Địa chỉ người mua")}
          </Grid>
          <Grid item sm={9} xs={8}>
            <TextField fullWidth value={input.customer_address || ""} onChange={(e) => setInput((prev) => ({ ...prev, customer_address: e.target.value }))} />
          </Grid>
          <Grid item sm={1} xs={2}>
            {t("Thông tin HĐ")}
          </Grid>
          <Grid item sm={2} xs={3}>
            <TextField label={t("Mẫu số")} fullWidth value={input.form || ""} onChange={(e) => setInput((prev) => ({ ...prev, form: e.target.value }))} />
          </Grid>
          <Grid item sm={2} xs={3}>
            <TextField label={t("Ký hiệu")} fullWidth value={input.serial || ""} onChange={(e) => setInput((prev) => ({ ...prev, serial: e.target.value }))} />
          </Grid>
          <Grid item sm={2} xs={3}>
            <TextField label={t("Số hóa đơn")} fullWidth value={input.code || ""} onChange={(e) => setInput((prev) => ({ ...prev, code: e.target.value }))} />
          </Grid>
          <Grid item sm={2} xs={3}>
            <CustomDatePicker label={t("Ngày xuất hóa đơn")} value={input.date} onChange={(value) => setInput((prev) => ({ ...prev, date: value }))} />
          </Grid>
          <Grid item sm={1} />
          <Grid item sm={1}>
            {t("Thông tin HH")}
          </Grid>
          <Grid item sm={2} xs={2}>
            <TextField label={t(t("Tiền trước thuế (VND)"))} fullWidth value={input.amount || ""} onChange={(e) => setInput((prev) => ({ ...prev, amount: e.target.value }))} />
          </Grid>
          <Grid item sm={2} xs={2}>
            <TextField
              type="number"
              sx={{ width: "100%" }}
              label={t("Thuế") + " (%)"}
              value={input.vat_rate || ""}
              onChange={(e) => setInput((prev) => ({ ...prev, vat_rate: e.target.value < 0 ? 0 : e.target.value > 100 ? 100 : e.target.value }))}
            />
          </Grid>
          <Grid item sm={2} xs={2}>
            <TextField fullWidth label={t("Tiền thuế")} value={input.vat || ""} onChange={(e) => setInput((prev) => ({ ...prev, vat: e.target.value }))} />
          </Grid>
          <Grid item sm={2} xs={2}>
            <TextField fullWidth label={t("Tổng tiền sau thuế")} value={input.total || ""} onChange={(e) => setInput((prev) => ({ ...prev, total: e.target.value }))} />
          </Grid>
          <Grid item sm={1} sx={{ display: { xs: "none", sm: "inherit" } }} />
          <Grid item sm={1} xs={2}>
            {t("Link web")}
          </Grid>
          <Grid item sm={3} xs={8}>
            <TextField multiline minRows={2} fullWidth value={input.link || ""} onChange={(e) => setInput((prev) => ({ ...prev, link: e.target.value }))} />
          </Grid>
          <Grid item sm={1} xs={2}>
            {t("Ghi chú")}
          </Grid>
          <Grid item sm={4} xs={8}>
            <TextField multiline minRows={2} fullWidth value={input.note || ""} onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))} />
          </Grid>
          <Grid item sm={1} />
        </Grid>
        <div style={{ margin: "10px 10px 0 0", display: "inline-flex" }}>
          <ButtonWithAPICall variant="contained" api={handleSubmit} response={onEditResponse}>
            {t("Lưu")}
          </ButtonWithAPICall>
        </div>
        <ButtonWithAPICall
          style={{ margin: "10px" }}
          color="error"
          variant="contained"
          api={handleDelete}
          response={onDeleteResponse}
          dialogNode={function (params) {
            // neu deleted thi co thong bao xac nhan xoa
            return <DeleteDialog {...params} />;
          }}
        >
          {t("Hủy hóa đơn")}
        </ButtonWithAPICall>
      </div>
    );
  return "";
};

export default EditPI;
